import React, { useCallback, useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Cookies from 'universal-cookie';
import { LoadingSkeleton } from '../assets/skeletons';
import { useMediaQuery } from 'react-responsive';
import { spanish } from '../languages/es';
import { english } from '../languages/en';
import Header from '../header/header';
import BottomMenu from '../footer/bottomMenu';
import { NotFoundGeneral } from '../assets/notFound';
import DatePicker from '../assets/datePicker';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { OptionsContext } from '../../App';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InstallationsList from './installations_list';
import { Button } from '@material-ui/core';
import DateRangeHandler from '../assets/dateRangeHandler';
import mysqlToJSDate from '../assets/mysqlToJSDate';
import TuneIcon from '@material-ui/icons/Tune';
import InstallationsFilters from './installationsFilters';
import HeaderTitle from '../assets/headerTitle';

const date = new Date();

const convertDate = (date) => {
    let df = date.replace(/[-]/g, '/');
    df = Date.parse(df);
    return new Date(df);
}

const Installations = (props) => {

    //Main States
    const [data, setData] = useState(false);
    const [error, setError] = useState({ code: false, message: "" });
    const [dateFrom, setDateFrom] = useState(false);
    const [dateTo, setDateTo] = useState(false);
    const [pickerDateFrom, setPickerDateFrom] = useState(false);
    const [pickerDateTo, setPickerDateTo] = useState(false);
    const [options, setOptions] = useContext(OptionsContext);
    const [showDateRange, setShowDateRange] = useState(false);
    const [showInstallationsFilters, setShowInstallationsFilters] = useState(false);
    const [ignorePendingInstallations, setIgnorePendingInstallations] = useState(options.ignorePendingInstallations);


    const language = english;

    //Secondary states
    const [skeleton, setSkeleton] = useState(true);

    //Config and options
    const history = useHistory();
    const cookie = new Cookies();
    const userLevel = cookie.get('level');
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isMobile = useMediaQuery({ query: '(max-width: 480px)' });

    const handleSetFromDate = (date) => {
        setDateFrom(date);
        setPickerDateFrom(date);
    }
    const handleSetToDate = (date) => {
        setDateTo(date);
        setPickerDateTo(date);
    }
    const DateFiltered = useCallback((from, to) => {
        setData(false);
        setSkeleton(true);
        setError({ code: false, message: "" });
        const ignorePending = ignorePendingInstallations ? '&ignore_pending=true' : '';
        Axios.get(
            `${props.host}/installations/dateFiltered?date_from=${from}&date_to=${to}${ignorePending}`,
            { headers: { Authorization: `Bearer ${props.token}` } })
            .then(res => {
                setData(res.data);

            })
            .catch((error) => {
                error && setError({ ...error, code: error.response.status, message: error.response.data });
            })
    }, [ignorePendingInstallations]);

    const FetchData = useCallback(() => {
        if (!dateFrom && !dateTo && props.match === undefined) {
            const initialDay = new Date(date.getFullYear(), date.getMonth(), 1);
            const today = new Date();
            const from = initialDay.getFullYear() + "-" + (initialDay.getMonth() + 1) + '-' + initialDay.getDate();
            const to = today.getFullYear() + "-" + (today.getMonth() + 1) + '-' + today.getDate();
            setPickerDateFrom(convertDate(from));
            setPickerDateTo(convertDate(to));
            DateFiltered(from, to);
            return;
        }
        if (dateFrom && dateTo) {
            const from = dateFrom.getFullYear() + "-" + (dateFrom.getMonth() + 1) + '-' + dateFrom.getDate();
            const to = dateTo.getFullYear() + "-" + (dateTo.getMonth() + 1) + '-' + dateTo.getDate();
            history.push(`/installations/filter_by_date/from/${from}/to/${to}`);
        }
    }, [dateFrom, dateTo, ignorePendingInstallations])

    const handleIgnorePendingInstallations = (event) => {
        setIgnorePendingInstallations(event.target.checked);
        setOptions({ ...options, 'ignorePendingInstallations': event.target.checked });
    }

    useEffect(() => {
        FetchData();
    }, [dateFrom, dateTo, ignorePendingInstallations]);

    useEffect(() => {
        if (props.match !== undefined) {
            const from = props.match.params.from_date;
            const to = props.match.params.to_date;
            console.log(props.match.params);
            DateFiltered(from, to);
            setPickerDateFrom(convertDate(from));
            setPickerDateTo(convertDate(to));
        }
    }, [props.match, DateFiltered]);


    useEffect(() => {
        !data && setSkeleton(true);
        data && setSkeleton(false);
    }, [data]);

    useEffect(() => {
        error.code && setSkeleton(false);
    }, [error]);


    return (
        <>

            {/* {isMobile &&
                <Header />
            } */}

            {/* {data && isMobile &&
                <MobileAppList applications={data} />
            } */}

            {/* <HeaderTitle title="Installations" /> */}

            <div style={{ display: 'flex', marginBottom: '10px' }}>
                <Button size='small'>
                    <DateRangeHandler text={props.match ? !ignorePendingInstallations ? `From ${mysqlToJSDate(props.match.params.from_date, { showTime: false })} To ${mysqlToJSDate(props.match.params.to_date, { showTime: false })} and Pending` : `From ${mysqlToJSDate(props.match.params.from_date, { showTime: false })} To ${mysqlToJSDate(props.match.params.to_date, { showTime: false })}` : !ignorePendingInstallations ? 'Current Month and Pending' : 'Current Month'} showDateRange={showDateRange} setShowDateRange={setShowDateRange} />
                </Button>
                <Button size='small' onClick={() => setShowInstallationsFilters(!showInstallationsFilters)}>
                    <TuneIcon style={{ padding: '12px', color: '#6c6c6c' }} />
                    <p>Special options</p>
                </Button>

            </div>

            <InstallationsFilters
                ignorePendingInstallations={ignorePendingInstallations}
                handleIgnorePendingInstallations={handleIgnorePendingInstallations}
                showInstallationsFilters={showInstallationsFilters}
                setShowInstallationsFilters={setShowInstallationsFilters}
            />

            {showDateRange &&
                <div style={{ display: 'flex', marginBottom: '1rem' }}>
                    <DatePicker style={{ margin: '0 10px', flexBasis: 'fit-content' }} label="Date From" setDate={(date) => handleSetFromDate(date)} date={pickerDateFrom} />
                    <DatePicker style={{ margin: '0 10px', flexBasis: 'fit-content' }} label="Date To" setDate={(date) => handleSetToDate(date)} date={pickerDateTo} />
                </div>
            }


            {!skeleton && data &&
                <InstallationsList data={data} host={props.host} token={props.token} />
            }
            {skeleton &&
                <LoadingSkeleton />
            }
            {error.code && <NotFoundGeneral message={error.message} />}
            <BottomMenu />



        </>
    )
}

export default Installations
